import { TextField } from "@mui/material";
import React, { ReactNode } from "react";

type BasicFormWithDefaultProps = {
  label: string;
  name: string;
  value?: string;
  defaultValue?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
  helperText?: string | ReactNode;
  isRequired?: boolean;
  placeholder?: string;
};

const BasicFormWithDefault: React.FC<BasicFormWithDefaultProps> = ({
  label,
  name,
  value,
  defaultValue = "",
  onChange,
  error = false,
  helperText = "",
  isRequired = true,
  placeholder = "",
}) => {
  return (
    <TextField
      label={label}
      variant="outlined"
      fullWidth
      name={name}
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      error={error}
      helperText={helperText}
      required={isRequired}
      placeholder={placeholder}
    />
  );
};

export default BasicFormWithDefault;
